import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Layout } from 'antd'

import Webcam from '../components/Webcam'
import FaceRect from '../components/FaceRect'
import requests from '../services/requests'

const INITIAL_STATE = {
  event: null,
  faces: [],
}

class Stream extends Component {
  state = INITIAL_STATE
  componentWillMount() {
    this.setState({ event: this.props.event })
  }
  async componentDidMount() {
    const { event } = this.state
    try {
      await requests.get(`/event/${event.id}/train`)
    } catch (err) {
      console.error(err)
    }
  }
  async handleWebcam(image) {
    const { event } = this.state
    try {
      const faces = await requests.post(`/event/${event.id}/identify${this.props.location.search}`, { image })
      this.setState({ faces })
    } catch (err) {
      console.error(err)
      this.setState({ faces: [] })
    }
  }
  render() {
    return (
      <Layout className="layout">
        <div style={{
          background: '#fff',
          minHeight: '100vh',
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        >
          <img
            src="/images/BANGSAEN42-2018_FaceID.png"
            alt="border"
            style={{
              display: 'block',
              position: 'absolute',
              width: 'auto',
              height: '100%',
              zIndex: 1,
            }}
          />
          <div style={{ position: 'relative', textAlign: 'center', marginTop: 'calc(100vh - 720px - 11%)' }}>
            <Webcam
              onCapture={image => this.handleWebcam(image)}
              interval={this.state.event.interval || 1000}
              width={1280}
              height={720}
            />
            {this.state.faces.map(({ faceId, faceRectangle, person }) => (
              <FaceRect
                key={faceId}
                label={(person && person.name) || 'Unknow'}
                faceId={faceId}
                {...faceRectangle}
              />
            ))}
          </div>
        </div>
      </Layout>
    )
  }
}
Stream.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    personGroupId: PropTypes.string,
    interval: PropTypes.number,
  }),
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
}
Stream.defaultProps = {
  event: {
    interval: 200,
  },
}

export default Stream



// WEBPACK FOOTER //
// ./src/pages/Stream.js